import { startRegistration, startAuthentication } from "@simplewebauthn/browser";
import { api } from "./api";

export const passkeySupported = () =>
  typeof window !== "undefined" && !!window.PublicKeyCredential;

export async function passkeyPlatformAvailable() {
  try {
    if (!passkeySupported()) return false;
    if (!window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable) return false;
    return await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
  } catch {
    return false;
  }
}

export function deviceLabel() {
  const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
  let os = "جهاز";
  if (/iPhone|iPad|iPod/i.test(ua)) os = "iPhone/iPad";
  else if (/Android/i.test(ua)) os = "Android";
  else if (/Macintosh|Mac OS/i.test(ua)) os = "Mac";
  else if (/Windows/i.test(ua)) os = "Windows";
  else if (/Linux/i.test(ua)) os = "Linux";
  let br = "متصفح";
  if (/Edg\//i.test(ua)) br = "Edge";
  else if (/OPR\//i.test(ua)) br = "Opera";
  else if (/Chrome\//i.test(ua) && !/Edg\//i.test(ua)) br = "Chrome";
  else if (/Firefox\//i.test(ua)) br = "Firefox";
  else if (/Safari\//i.test(ua)) br = "Safari";
  return `${os} · ${br}`;
}

export async function registerPasskey() {
  const origin = window.location.origin;
  const o = await api.webauthnRegisterOptions(origin);
  const credential = await startRegistration({ optionsJSON: o.options });
  return api.webauthnRegisterVerify({ challenge_id: o.challenge_id, credential, origin, device_name: deviceLabel() });
}

export async function loginWithPasskey(identifier, accountType) {
  const origin = window.location.origin;
  const o = await api.webauthnLoginOptions(identifier, accountType, origin);
  const credential = await startAuthentication({ optionsJSON: o.options });
  return api.webauthnLoginVerify({ challenge_id: o.challenge_id, credential, origin });
}

export async function attendanceBio(purpose = "attendance") {
  const origin = window.location.origin;
  const o = await api.portalBioOptions(origin, purpose);
  const credential = await startAuthentication({ optionsJSON: o.options });
  return { challenge_id: o.challenge_id, credential, origin };
}

// Fingerprint-confirm a document if the employee has a passkey; returns null otherwise.
export async function optionalBio(purpose) {
  try {
    if (!passkeySupported()) return null;
    const p = await api.portalBioPolicy();
    if (!p.has_passkey) return null;
    return await attendanceBio(purpose);
  } catch {
    return null;
  }
}

export async function loginWithPasskeyDiscoverable(accountType) {
  const origin = window.location.origin;
  const o = await api.webauthnLoginDiscoverableOptions(accountType, origin);
  const credential = await startAuthentication({ optionsJSON: o.options });
  return api.webauthnLoginVerify({ challenge_id: o.challenge_id, credential, origin });
}
